import {ReactNode} from "react";
import {css, cx} from "@panda/css";

import {BrandLightBulbIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

interface Props {
    title?: string;
    children: ReactNode;
    className?: string;
}

export const PricesInsightBox = (props: Props) => {
    const {title, children, className} = props;
    const {isMobile} = useUserDevice();

    return (
        <div className={cx(wrapperStyle, className)}>
            <BrandLightBulbIcon size={isMobile ? "3.5" : "5"} wrapperSize={isMobile ? "4.4" : "6.4"} wrapperColor="transparent" />

            <div className={contentStyle}>
                {title && (
                    <Text variant="headline_5" as="p" color="var(--colors-secondary)">
                        {title}
                    </Text>
                )}

                <Text variant="body_copy_0" color="var(--colors-secondary)">
                    {children}
                </Text>
            </div>
        </div>
    );
};

const wrapperStyle = css({
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 2,
    p: 1,
    backgroundColor: "var(--colors-background-200)",
    borderRadius: 2,

    md: {
        py: 2.5,
        px: 3
    }
});

const contentStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    minWidth: 0
});
import {ReactNode} from "react";
import {css, cx} from "@panda/css";

import {BrandLightBulbIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

interface Props {
    title?: string;
    children: ReactNode;
    className?: string;
}

export const PricesInsightBox = (props: Props) => {
    const {title, children, className} = props;
    const {isMobile} = useUserDevice();

    return (
        <div className={cx(wrapperStyle, className)}>
            <BrandLightBulbIcon size={isMobile ? "3.5" : "5"} wrapperSize={isMobile ? "4.4" : "6.4"} wrapperColor="transparent" />

            <div className={contentStyle}>
                {title && (
                    <Text variant="headline_5" as="p" color="var(--colors-secondary)">
                        {title}
                    </Text>
                )}

                <Text variant="body_copy_0" color="var(--colors-secondary)">
                    {children}
                </Text>
            </div>
        </div>
    );
};

const wrapperStyle = css({
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 2,
    p: 1,
    backgroundColor: "var(--colors-background-200)",
    borderRadius: 2,

    md: {
        py: 2.5,
        px: 3
    }
});

const contentStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    minWidth: 0
});
